<template lang="html">
    <div>
        <div v-if="videoInfo && tm" class="container-fulid position-r materialStudy-wrap">
            <div class="row pt-5 tm-wrapper" :class="[ activetab ? 'move' : '']">
                <div class="col-md-5" :class="[ changeVideoData ? '' : 'col-md-12']">
                    <div :class="[ changeVideoData ? '' : 'close-video']">
                        <h1>{{fmtTMName(tm)}}</h1>
                        <ul class="row mt-3">
                            <li class="col-5 tm-num-text">
                                <img class="mr-2" alt=""
                                     src="@/assets/image/tm-CCount.svg">{{fmtTranslateCount(tm.TMCCount)}}
                            </li>
                            <li v-if="vlFindingStatistic" class="col-7 mb-2 tm-num-text">
                                <img class="mr-2" alt=""
                                     src="@/assets/image/tm-findText.svg">{{$t('page_material_study.user_found_lex')}} : {{vlFindingStatistic.LeixconFoundByUser}}
                            </li>
                            <li class="col-5 tm-num-text">
                                <img class="mr-2" alt=""
                                     src="@/assets/image/tm-LCount.svg">{{$t('page_material_study.lex_count')}} : {{tm.TMLCount}}
                            </li>
                            <li v-if="vlFindingStatistic" class="col-7 tm-num-text">
                                <img class="mr-2" alt=""
                                     src="@/assets/image/tm-NfindText.svg">{{$t('page_material_study.lex_not_found')}} : {{vlFindingStatistic.LexiconWaitingToBeFound}}
                            </li>
                        </ul>
                        <div class="text-gray flex-between w-100">
                            <div>
                                <img class="anthorCricle-image mr-2" :src="fmtAuthorAvatorUrl" @click="onAuthorClicked"
                                     alt="">{{tm.CreateDate.split('T')[0] }}
                            </div>
                            <div>
                                <span class="Corpus-social mr-3">
                                    <img alt="" src="@/assets/image/video-readviews.svg" class="mr-1">{{ tm.WatchCount ? tm.WatchCount : 0 }}
                                </span>
                                <span class="Corpus-social">
                                    <img v-if="this.tm && this.tm.IsUserLike" alt="" src="@/assets/image/lexprogress-video-heart-active.svg"
                                         class="mr-1" style="cursor:pointer;"
                                         v-on:click="userClaps">
                                    <img v-else alt="" src="@/assets/image/lexprogress-video-heart.svg"
                                         class="mr-1" :style="{'cursor':user?'pointer':'default'}"
                                         v-on:click="userClaps">
                                    {{ tm.LikeCount ? tm.LikeCount : 0 }}
                                </span>
                            </div>
                        </div>
                        <hr>
                    </div>
                    <h2 v-if="videoInfo" class="mt-2">{{videoInfo.Title}}</h2>
                    <div class="d-flex mb-2">
                        <div v-if="accentTypes && videoInfo && videoInfo.AccentTypeId" class="label-primary mr-2">{{fmtAccentTypeName}}</div>
                        <!-- 先移除 youtube 的數據，有足夠的 quote 時再來顯示
                        <img src="@/assets/image/youtube-icon-gray.svg" alt=""
                             class="youtube-icon-view">
                        <div v-if="videoInfo" class="youtube-num-text text-gray">{{fmtCountAbbr(videoInfo.YoutubeWatchCount)}}</div><img src="@/assets/image/youtube-thumb-gray.svg" alt="" class="youtube-icon-like">
                        <div v-if="videoInfo" class="youtube-num-text text-gray">{{fmtCountAbbr(videoInfo.YoutubeLikeCount)}}</div>
                        -->
                    </div>
                    <i-yu-yan-player v-if="videoCaptions && tmcs" ref="yyPlayer"
                                     :video-info="videoInfo" :video-captions="videoCaptions" :dict-captions="dictVideoCaptions"
                                     :disable-subtitles="true" :autoplay="true" :videoLoadStart="getVideoLoadStart"
                                     @pushexpandVideoData="getNewData"
                                     @video-playing-caption-changed="onVideoPlayingCaptionChanged">
                    </i-yu-yan-player>
                </div>
                <div v-if="videoCaptions && dictVideoCaptions" class="col-md-7" :class="[ changeVideoData ? '' : 'close-video']">
                    <h1 v-if="tm" class="mb-2">
                        <span v-on:click="toggleTMCollecting" :style="{'cursor': tm.IsCollected?(user.IsAdmin?'pointer':'default'):'pointer'}"
                              v-bind:class="[ tm.IsCollected  ? 'bookmarks-active' : 'bookmarks' ]">
                        </span>
                        <div class="bookmarks-remind" @click="openRemind = !openRemind" :class="{'show':openRemind}">
                            {{$t('page_material_study.bookmark_hint')}}
                            <div class="close-btn">
                                <i class="fas fa-times"></i>
                            </div>
                            <div class="remind-tringle"></div>
                        </div>
                        {{fmtTMName(tm)}}
                        <i class="fas fa-share-alt fa-sm ml-5" style="cursor:pointer;" @click="getVideoShareUrl"></i>
                    </h1>
                    <div class="videoCaptionsData-tag mb-4">
                        <div v-if="!tags || tags.length == 0"><span>#Lorem ipsum</span><span>#Lorem ipsum</span></div>
                        <div v-else><span v-for="t in tags" :key="t.Id" @click="listMaterialWithTag(t)">#{{t.Name}}</span></div>
                    </div>
                    <video-caption-list v-if="tm && videoCaptions" :user="user" :class="[ changeVideoData ? '' : 'video-open-height']" :tm="tm" ref="videoCaptionCtrl"
                                        :video-captions="videoCaptions" :dict-video-captions="dictVideoCaptions"
                                        :dictTMCS="dictTMCS" :dictTMLS="dictTMLS" :videoShareInfo="videoShareInfo"
                                        v-on:caption-clicked="onCaptionClicked"
                                        @show-bookmark-remind="showBookmarkReminder"
                                        @caption-shadowing-request="onCaptionShadowingRequest"></video-caption-list>
                </div>
                <br />
            </div>
            <!-- 生字表 -->
            <div class="tab-content">
                <div class="tranglationBody tabcontent" v-if="activetab == 1">
                    <h5 class="modal-title">{{$t('page_material_study.vocabulary')}}</h5>
                    <div class="close-btn" v-on:click="setTab(0)">
                        <i class="fas fa-times"></i>
                    </div>
                    <div class="tmls-content-wrap">
                        <div class="list-wrap-border w-100 flex-between flex-nowrap" v-for="tmlsdata in tmls" :key="tmlsdata.Id">
                            <div class="text-left">
                                <div class="tmls-title-wrap">
                                    <p class="mb-1 title-bold tmls-title" @click="openLexAdvInfo(tmlsdata)">{{tmlsdata.LexiconLearningTitle}}</p>
                                </div>
                                <p class="mb-1 text-black">{{tmlsdata.LexiconNativeTitle}}</p>
                                <p v-if="dictTMCS && (tmlsdata.VideoCaptionId in dictTMCS)" style="cursor:pointer;" @click="onTMLCaptionClicked(tmlsdata)">
                                    {{dictTMCS[tmlsdata.VideoCaptionId].Text}}
                                </p>
                            </div>
                            <div class="flex-center p-3">
                                <i class="fas fa-plus" style="cursor:pointer" v-on:click="addUserTML(tmlsdata)"></i>
                            </div>
                        </div>
                    </div>
                    <div class="gradual-mask"></div>
                    <div class="w-100 d-flex-center mt-4"><button class="btn btn-second" v-on:click="setTab(0)">{{$t('page_material_study.close')}}</button></div>
                </div>
                <!-- 我的收藏 -->
                <div class="tranglationBody tabcontent" v-if="activetab == 2">
                    <h5 class="modal-title">{{$t('page_material_study.my_collected_lex')}}</h5>
                    <div class="close-btn" v-on:click="setTab(0)">
                        <i class="fas fa-times"></i>
                    </div>
                    <div v-if="utmls && utmls.length > 0" class="tmls-content-wrap">
                        <div class="list-wrap-border w-100 flex-between flex-nowrap" v-for="(utml, utmlIdx) in utmls" :key="utml.TeachingMaterialLexiconId">
                            <div class="text-left">
                                <div class="tmls-title-wrap">
                                    <p class="mb-1 title-bold tmls-title" @click="openLexAdvInfo(dictTMLS[utml.TeachingMaterialLexiconId])">
                                        {{dictTMLS[utml.TeachingMaterialLexiconId].LexiconLearningTitle}}
                                    </p>
                                </div>
                                <p class="mb-1 text-black">{{dictTMLS[utml.TeachingMaterialLexiconId].LexiconNativeTitle}}</p>
                                <p v-if="isUTMLCaptionVisible(utml)">{{fmtUTMLCaption(utml)}}</p>
                            </div>
                            <div class="flex-center p-3">
                                <i class="fas fa-trash" style="cursor:pointer" v-on:click="removeUserTML(utml, utmlIdx)"></i>
                            </div>
                        </div>
                    </div>
                    <div v-else>
                        <p>{{$t('page_material_study.no_user_collected_lex')}}</p>
                    </div>
                    <div class="gradual-mask"></div>
                    <div class="w-100 d-flex-center mt-4"><button class="btn btn-second" v-on:click="setTab(0)">{{$t('page_material_study.close')}}</button></div>
                </div>
                <!-- 心得討論 -->
                <div class="tranglationBodyNotebook" v-show="activetab == 3">
                    <h5 class="modal-title">{{$t('page_material_study.study_notebook')}}</h5>
                    <div class="close-btn" v-on:click="setTab(0)">
                        <i class="fas fa-times"></i>
                    </div>
                    <textarea class="" id="" name="" rows="5" v-model="tm.Comment" disabled>
                    </textarea>
                    <div style="width:100%;height:20rem;">
                        <!--
                        <fb-comment :url="fbDataUrl"></fb-comment>    
                        -->
                        <teaching-material-comment :user="user" :tmId="tmId"></teaching-material-comment>
                    </div>
                    <!-- 改為作者的學習筆記
                    <div class="w-100 d-flex-center mt-4"><button class="btn btn-second" @click="updateUserTMComment">送出</button></div>
                    -->
                    <div class="w-100 d-flex-center mt-4"><button class="btn btn-second" v-on:click="setTab(0)">{{$t('page_material_study.close')}}</button></div>
                </div>
                <!-- 衍生學習 -->
                <div class="tranglationBody" id="tabs-4" role="tabpanel" v-if="activetab == 4">
                    <h5 class="modal-title">{{$t('page_material_study.derivated_learning')}}</h5>
                    <div class="close-btn" v-on:click="setTab(0)">
                        <i class="fas fa-times"></i>
                    </div>
                    <div v-for="sv in suggestVideos" :key="sv.VideoInfoId">
                        <img :src="'https://img.youtube.com/vi/' + sv.VideoId + '/hqdefault.jpg'"
                             class="w-100 extendLearn-img" @click="playVideo(sv)">
                        <p class="hide-text-2">{{fmtSuggestVideoReason(sv)}}</p>
                        <hr>
                    </div>
                </div>
            </div>
            <ul class="nav nav-tabs toolBtn-wrap" role="tablist">
                <li class="nav-item">
                    <a v-on:click="setTab(1)" v-bind:class="[ activetab == 1 ? 'active' : '' ]" class="nav-link">{{$t('page_material_study.vocabulary')}}</a>
                </li>
                <div class="btn-line"></div>
                <li class="nav-item">
                    <a class="nav-link" v-on:click="setTab(3)" v-bind:class="[ activetab == 3 ? 'active' : '' ]">{{$t('page_material_study.study_notebook')}}</a>
                </li>
                <div class="btn-line"></div>
                <li class="nav-item">
                    <a v-on:click="setTab(2)" v-bind:class="[ activetab == 2 ? 'active' : '' ]" class="nav-link">{{$t('page_material_study.my_collected_lex')}}</a>
                </li>
                <div class="btn-line"></div>
                <li class="nav-item">
                    <a class="nav-link" v-on:click="setTab(4)" v-bind:class="[ activetab == 4 ? 'active' : '' ]">{{$t('page_material_study.derivated_learning')}}</a>
                </li>
            </ul>
        </div>
        <div v-else>
            <h5>{{$t('page_material_study.tm_not_found')}}</h5>
        </div>
        <!-- Shadowing Modal -->
        <shadowing-tool ref="shadowingModal"></shadowing-tool>
    </div>
</template>

<script>
    import VideoCaptionList from '@/components/Elements/VideoCaptionList';
    import YuYanPlayer from '@/components/Elements/YuYanPlayer';
    import {
        abbrCount,
        fmtAuthorAvatorUrl,
        ghelper,
        gotoAuthorProfile
    } from '@/lib/ghelper';

    import ShadowingModal from '@/components/Elements/ShadowingTool.vue';
    //import FbComment from '@/components/Elements/FbComment.vue';
    import TeachingMaterialComment from '@/components/Elements/TeachingMaterialComment.vue';

    export default {
        props: {
            user: {
                type: Object,
                default: null,
            },
            isPhone: {
                type: String,
                default: null,
            },
            tmId: {
                type: String,
                default: null,
            },
            videoId: {
                type: String,
                default: null,
            },
            videoStart: {
                type: Number,
                default: null,
            },
            videoShareInfo: {
                type: Object,
                default: null,
            }
        },
        components: {
            'video-caption-list': VideoCaptionList,
            'i-yu-yan-player': YuYanPlayer,
            'shadowing-tool': ShadowingModal,
            //'fb-comment': FbComment,
            'teaching-material-comment': TeachingMaterialComment,
        },
        data: function () {
            return {
                videoInfo: null,
                accentTypes: null,

                videoCaptions: null,
                dictVideoCaptions: null,
                selectedVideoCaptionIdx: null,
                selectedVideoCaption: null,

                tm: null, // TeachingMaterial
                tmcs: null, // TeachingMaterialCaptions
                tmls: null, // TeachingMaterialLexicons
                utmls: null, // UserTeachingMaterialLexicons
                tags: null, // tags of teaching material
                dictTMCS: null,
                dictTMLS: null,
                openModel:false,
                activetab: 0,

                // 詞彙的尋寶統計
                vlFindingStatistic: null,
                changeVideoData: true,

                // suggest videos
                suggestVideos: null,
                openRemind: false
            };
        },
        methods: {
            getVideoShareUrl: async function () {
                if (this.videoShareInfo) {
                    // from videoshare
                    this.$gtag.event('get_video_share_url', {
                        'event_category': 'iyuyan',
                        'event_label': 'video_share',
                        'value': 300
                    });
                } else {
                    this.$gtag.event('get_video_share_url', {
                        'event_category': 'iyuyan',
                        'event_label': 'material_study',
                        'value': 300
                    });
                }

                let vs = await this.getVideoShare();

                if (vs == null) {
                    vs = await this.createVideoShare();
                }

                if (vs) {
                    let vsMsg = this.$t('page_material_study.video_share_url') + ' https://www.iyuyan.net/VideoShare/Index4/' + vs.HashId;
                    this.$dialog.alert(vsMsg);
                } else {
                    this.$dialog.alert(this.$t('page_material_study.cannot_create_vs'));
                }
            },
            getVideoShare: async function () {
                if (this.tm.VideoShare) {
                    return this.tm.VideoShare;
                }

                if (!this.tm.VideoShareId) {
                    return null;
                }

                try {
                    var loader = this.$loading.show();
                    let res = await this.axios.post("Material/GetVideoShare", {
                        sid: this.tm.VideoShareId,
                    });

                    let data = res.data;
                    let vs = data.data;
                    this.$set(this.tm, 'VideoShare', vs);
                    loader.hide();

                    return vs;
                } catch (error) {
                    if (error.response) {
                        // 當狀態碼不在 validateStatus 設定的範圍時進入, 401 感覺會跑來這。待確認
                        // 有 data / status / headers 參數可用
                        console.log(error.response.status);
                    } else if (error.request) {
                        // 發送請求，但沒有接到回應
                        // error.request is an instance of XMLHttpRequest in the browser
                        // and an instance of http.ClientRequest in node.js
                        console.log(error.request);
                    } else {
                        // 在設定 request 時出錯會進入此
                        console.log("Error", error.message);
                    }
                    this.$dialog.alert("無法執行作業。發生不知名的錯誤");
                    loader.hide();

                    return null;
                }
            },
            createVideoShare: async function () {
                var newShareDate = new Date();
                newShareDate.setMonth(newShareDate.getMonth() + 1);

                if (this.tm.VideoShare && this.tm.VideoShare.ShareDeadline) {
                    if (this.tm.VideoShare.ShareDeadline == newShareDate) {
                        return; // same, skip
                    }
                }

                try {
                    var loader = this.$loading.show();
                    let res = await this.axios.post("Material/TeachingMaterialShare", {
                        tmid: this.tm.Id,
                        dl: newShareDate,
                    });

                    let data = res.data;

                    loader.hide();
                    if (data.success) {
                        var vs = data.data;
                        this.$set(this.tm, 'VideoShare', vs);

                        return vs;
                    }

                    this.$dialog.alert(data.message);
                    return null;
                } catch (error) {
                    if (error.response) {
                        // 當狀態碼不在 validateStatus 設定的範圍時進入, 401 感覺會跑來這。待確認
                        // 有 data / status / headers 參數可用
                        console.log(error.response.status);
                    } else if (error.request) {
                        // 發送請求，但沒有接到回應
                        // error.request is an instance of XMLHttpRequest in the browser
                        // and an instance of http.ClientRequest in node.js
                        console.log(error.request);
                    } else {
                        // 在設定 request 時出錯會進入此
                        console.log("Error", error.message);
                    }
                    this.$dialog.alert("無法執行作業。發生不知名的錯誤");
                    loader.hide();
                    return null;
                }
            },
            fmtTMName: function (tm) {
                if (tm.Name) {
                    return tm.Name;
                } else {
                    return this.$t('page_material_study.unknown_tm_name');
                }
            },
            fmtTranslateCount: function (tmcCount) {
                let title = this.$t('page_material_study.translation_count');

                return title + ': ' + tmcCount;
            },
            listMaterialWithTag: function (t) {
                if (this.user) {
                    var materialIndex = ghelper.getActionUrl('Index', 'Material');
                    location.href = materialIndex + "?m=7&t=" + t.Id;
                } else {
                    let loginHint = this.$t('page_material_study.login_hint');
                    this.$dialog.alert(loginHint);
                }
            },
            onCaptionShadowingRequest: function (cap, capIdx) {
                if (this.videoShareInfo) {
                    // from videoshare
                    this.$gtag.event('caption_shadowing_request', {
                        'event_category': 'iyuyan',
                        'event_label': 'video_share',
                        'value': 150
                    });
                } else {
                    this.$gtag.event('caption_shadowing_request', {
                        'event_category': 'iyuyan',
                        'event_label': 'material_study',
                        'value': 150
                    });
                }

                this.$refs.yyPlayer.pauseVideo();
                this.$refs.shadowingModal.open(this.$refs.yyPlayer, cap, capIdx);
            },
            playVideo: function (vi) {
                if (this.videoShareInfo) {
                    // from videoshare
                    this.$gtag.event('play_derivated_video', {
                        'event_category': 'iyuyan',
                        'event_label': 'video_share',
                        'value': 150
                    });
                } else {
                    this.$gtag.event('play_derivated_video', {
                        'event_category': 'iyuyan',
                        'event_label': 'material_study',
                        'value': 150
                    });
                }

                var appUrl = ghelper.getActionUrl('PlayVideoBS', 'Video');
                location.href = appUrl + "?v=" + vi.VideoId + '&lang=' + vi.Lang;
            },
            openLexAdvInfo: function (tml) {
                if (this.user) {
                    let appUrl = ghelper.getActionUrl('AdvInfo', 'Lex');
                    let urlFull = appUrl + '/' + tml.LexiconLearningId + '/' + this.tm.LangCharsetCodeTranslated;
                    window.open(urlFull, '_blank');
                } else {
                    let loginHint = this.$t('page_material_study.login_hint');
                    this.$dialog.alert(loginHint);
                    return;
                }
            },
            getNewData: function (newData) {
                this.changeVideoData = newData
                console.log(newData)
            },
            showBookmarkReminder: function () {
                this.openRemind = true;

                window.scrollTo(0, 0);
            },
            setTab: async function (newTab) {
                if (newTab == this.activetab) {
                    this.activetab = null;
                } else {
                    if (newTab > 0 && (newTab != 1 && newTab != 3)) {
                        // 先關閉
                        /*
                        if (!this.tm.IsCollected) {
                            if (this.user) {
                                this.showBookmarkReminder();
                                return;
                            } else {
                                let loginHint = this.$t('page_material_study.login_hint');
                                this.$dialog.alert(loginHint);
                                return;
                            }
                        }*/
                        if (!this.user) {
                            let loginHint = this.$t('page_material_study.login_hint');
                            this.$dialog.alert(loginHint);
                            return;
                        }

                        switch (newTab) {
                            case 4:
                                if (!this.suggestVideos) {
                                    this.getSuggestVideosFromTM();
                                }
                                break;

                            default:
                                break;
                        }
                    }

                    if ((newTab == 1 || newTab == 2) && !this.tmls) {
                        await this.getAllTML();
                    }

                    this.activetab = newTab
                }
            },

            fmtCountAbbr: function (c) {
                return abbrCount(c) + '次';
            },
            onCaptionClicked: function (event, cap, capIdx) {
                this.doCaptionClick(cap, capIdx);
            },
            doCaptionClick: function (cap, capIdx) {
                this.selectedVideoCaptionIdx = capIdx;
                this.selectedVideoCaption = cap;

                this.$refs.yyPlayer.playCaption(cap);
            },
            scrollerTop: function () {
                window.document.body.scrollTop = 0;
                window.document.documentElement.scrollTop = 0;
            },
            alert: function (msg) {
                this.$modal.show("dialog", {
                    title: "請注意",
                    text: msg,
                    buttons: [{
                        title: "關閉",
                    }, ],
                });
            },
            fmtSuggestVideoReason: function (sv) {
                if (sv.MatchedTerms != null) {
                    return '您可以學習到： ' + sv.MatchedTerms.join(', ');
                }

                return null;
            },
            fmtUTMLCaption: function (utml) {
                if (!this.dictTMCS || !this.dictTMLS) {
                    return;
                }

                let tml = this.dictTMLS[utml.TeachingMaterialLexiconId];
                if (tml.VideoCaptionId in this.dictTMCS) {
                    return this.dictTMCS[tml.VideoCaptionId].Text;
                }

                return;
            },
            isUTMLCaptionVisible: function (utml) {
                if (!this.dictTMCS) {
                    return false;
                }

                let tml = this.dictTMLS[utml.TeachingMaterialLexiconId];
                if (tml.VideoCaptionId in this.dictTMCS) {
                    return true;
                }

                return false;
            },
            onTMLCaptionClicked: function (tml) {
                let vc = this.dictVideoCaptions[tml.VideoCaptionId];
                if (vc != null) {
                    // goto with scrolling, this event is trigger by user clicked the caption of tml.
                    this.$refs.videoCaptionCtrl.gotoCaption(vc.cap);
                    this.$refs.yyPlayer.playCaption(vc.cap);
                }
            },
            onVideoPlayingCaptionChanged: function (capOld, capNew) {
                if (capNew) {
                    if (this.$refs.videoCaptionCtrl) {
                        if (this.selectedVideoCaption && this.selectedVideoCaption.No == capNew.No) {
                            // goto with skip Scroll, this event is trigger by user clicked the caption list control
                            this.$refs.videoCaptionCtrl.gotoCaption(capNew, true);
                        } else {
                            this.$refs.videoCaptionCtrl.gotoCaption(capNew);
                        }
                    }
                }
            },
            /* 改為作者的學習筆記
            updateUserTMComment: async function () {
                var loader = this.$loading.show();

                try {
                    let res = await this.axios.post("Data/UpdateUserTMComment", {
                        tmId: this.tmId,
                        c: this.tm.Comment,
                    });

                    let data = res.data;

                    if (data.success) {
                        this.$dialog.alert('更新成功。');
                    } else {
                        this.$dialog.alert(data.message);
                    }
                    loader.hide();
                } catch (error) {
                    if (error.response) {
                        // 當狀態碼不在 validateStatus 設定的範圍時進入, 401 感覺會跑來這。待確認
                        // 有 data / status / headers 參數可用
                        console.log(error.response.status);
                    } else if (error.request) {
                        // 發送請求，但沒有接到回應
                        // error.request is an instance of XMLHttpRequest in the browser
                        // and an instance of http.ClientRequest in node.js
                        console.log(error.request);
                    } else {
                        // 在設定 request 時出錯會進入此
                        console.log("Error", error.message);
                    }
                    this.$dialog.alert("無法更新使用者的學習筆記。發生不知名的錯誤");
                    loader.hide();
                }
            },
            */
            getTeachingMaterialTags: async function () {
                try {
                    let res = await this.axios.post("Data/GetTeachingMaterialTags", {
                        tmId: this.tmId,
                    });

                    let data = res.data;

                    if (data.success) {
                        this.tags = data.data;
                    } else {
                        this.$dialog.alert(data.message);
                    }
                } catch (error) {
                    if (error.response) {
                        // 當狀態碼不在 validateStatus 設定的範圍時進入, 401 感覺會跑來這。待確認
                        // 有 data / status / headers 參數可用
                        console.log(error.response.status);
                    } else if (error.request) {
                        // 發送請求，但沒有接到回應
                        // error.request is an instance of XMLHttpRequest in the browser
                        // and an instance of http.ClientRequest in node.js
                        console.log(error.request);
                    } else {
                        // 在設定 request 時出錯會進入此
                        console.log("Error", error.message);
                    }
                    this.$dialog.alert("無法取得教材的主題標籤。發生不知名的錯誤");
                }
            },
            getSuggestVideosFromTM: async function () {
                var loader = this.$loading.show();

                try {
                    let res = await this.axios.post("Data/GetSuggestVideosFromTM", {
                        tmId: this.tmId,
                    });

                    let data = res.data;

                    if (data.success) {
                        this.suggestVideos = data.data;
                    } else {
                        this.$dialog.alert(data.message);
                    }
                    loader.hide();
                } catch (error) {
                    if (error.response) {
                        // 當狀態碼不在 validateStatus 設定的範圍時進入, 401 感覺會跑來這。待確認
                        // 有 data / status / headers 參數可用
                        console.log(error.response.status);
                    } else if (error.request) {
                        // 發送請求，但沒有接到回應
                        // error.request is an instance of XMLHttpRequest in the browser
                        // and an instance of http.ClientRequest in node.js
                        console.log(error.request);
                    } else {
                        // 在設定 request 時出錯會進入此
                        console.log("Error", error.message);
                    }
                    this.$dialog.alert("無法取得衍生的學習影片。發生不知名的錯誤");
                    loader.hide();
                }
            },
            getVideoLexiconFindingStatistic: async function () {
                var loader = this.$loading.show();

                try {
                    let res = await this.axios.post("Data/GetVideoLexiconFindingStatistic", {
                        tmId: this.tmId,
                    });

                    let data = res.data;

                    if (data.success) {
                        this.vlFindingStatistic = data.data;
                    } else {
                        this.$dialog.alert(data.message);
                    }
                    loader.hide();
                } catch (error) {
                    if (error.response) {
                        // 當狀態碼不在 validateStatus 設定的範圍時進入, 401 感覺會跑來這。待確認
                        // 有 data / status / headers 參數可用
                        console.log(error.response.status);
                    } else if (error.request) {
                        // 發送請求，但沒有接到回應
                        // error.request is an instance of XMLHttpRequest in the browser
                        // and an instance of http.ClientRequest in node.js
                        console.log(error.request);
                    } else {
                        // 在設定 request 時出錯會進入此
                        console.log("Error", error.message);
                    }
                    this.$dialog.alert("無法影片詞彙尋寶統計資訊。發生不知名的錯誤");
                    loader.hide();
                }
            },
            getAccentTypes: async function (lang) {
                try {
                    let lls = lang.substring(0, 2);
                    let res = await this.axios.post("Data/GetAccentTypes", {
                        lls: lls,
                    });

                    let data = res.data;

                    if (data.success) {
                        this.accentTypes = data.data;
                    } else {
                        this.$dialog.alert(data.message);
                    }
                } catch (error) {
                    if (error.response) {
                        // 當狀態碼不在 validateStatus 設定的範圍時進入, 401 感覺會跑來這。待確認
                        // 有 data / status / headers 參數可用
                        console.log(error.response.status);
                    } else if (error.request) {
                        // 發送請求，但沒有接到回應
                        // error.request is an instance of XMLHttpRequest in the browser
                        // and an instance of http.ClientRequest in node.js
                        console.log(error.request);
                    } else {
                        // 在設定 request 時出錯會進入此
                        console.log("Error", error.message);
                    }
                    this.$dialog.alert("無法讀取口音資訊。發生不知名的錯誤");
                }
            },
            getVideoInfo: async function () {
                var loader = this.$loading.show();

                try {
                    let res = await this.axios.post("Video/GetVideoInfo", {
                        v: this.videoId,
                    });

                    let data = res.data;

                    if (data.success) {
                        this.videoInfo = data.data;

                        if (this.videoInfo.AccentTypeId) {
                            // load accent types data if we have accentTypeId
                            this.getAccentTypes(this.videoInfo.VideoLang);
                        }
                    } else {
                        this.$dialog.alert(data.message);
                    }
                    loader.hide();
                } catch (error) {
                    if (error.response) {
                        // 當狀態碼不在 validateStatus 設定的範圍時進入, 401 感覺會跑來這。待確認
                        // 有 data / status / headers 參數可用
                        console.log(error.response.status);
                    } else if (error.request) {
                        // 發送請求，但沒有接到回應
                        // error.request is an instance of XMLHttpRequest in the browser
                        // and an instance of http.ClientRequest in node.js
                        console.log(error.request);
                    } else {
                        // 在設定 request 時出錯會進入此
                        console.log("Error", error.message);
                    }
                    this.$dialog.alert("無法取得學習影片資訊。發生不知名的錯誤");
                    loader.hide();
                }
            },
            toggleTMCollecting: async function () {
                if (this.videoShareInfo) {
                    // from videoshare
                    this.$gtag.event('tm_collecting', {
                        'event_category': 'iyuyan',
                        'event_label': 'video_share',
                        'value': 250
                    });
                } else {
                    this.$gtag.event('tm_collecting', {
                        'event_category': 'iyuyan',
                        'event_label': 'material_study',
                        'value': 250
                    });
                }


                if (this.tm.IsCollected && !this.user.IsAdmin) {
                    return; // skip toggle, user cannot uncheck
                }

                if (!this.user) {
                    let loginHint = this.$t('page_material_study.login_hint');
                    this.$dialog.alert(loginHint);
                    return;
                }

                if (this.tm.AuthorId == this.user.HashedUserId) {
                    // the author, skip it.
                    return;
                }

                var loader = this.$loading.show();

                try {
                    let res = await this.axios.post("Data/ToggleTMCollecting", {
                        tmId: this.tmId,
                    });

                    let data = res.data;

                    if (data.success) {
                        let isCollected = data.data;
                        this.$set(this.tm, 'IsCollected', isCollected);
                    } else {
                        this.$dialog.alert(data.message);
                    }
                    loader.hide();
                } catch (error) {
                    if (error.response) {
                        // 當狀態碼不在 validateStatus 設定的範圍時進入, 401 感覺會跑來這。待確認
                        // 有 data / status / headers 參數可用
                        console.log(error.response.status);
                    } else if (error.request) {
                        // 發送請求，但沒有接到回應
                        // error.request is an instance of XMLHttpRequest in the browser
                        // and an instance of http.ClientRequest in node.js
                        console.log(error.request);
                    } else {
                        // 在設定 request 時出錯會進入此
                        console.log("Error", error.message);
                    }
                    this.$dialog.alert("無法切換教材的搜集資訊。發生不知名的錯誤");
                    loader.hide();
                }
            },
            onAuthorClicked: function () {
                gotoAuthorProfile(this.tm);
            },
            userClaps: async function () {
                if (!this.user) {
                    let loginHint = this.$t('page_material_study.login_hint');
                    this.$dialog.alert(loginHint);
                    return;
                }

                var loader = this.$loading.show();
                try {
                    let res = await this.axios.post("Data/UserClaps", {
                        tmId: this.tmId,
                    });

                    let data = res.data;

                    if (data.success) {
                        let newClapsCount = data.data;
                        if (!this.tm.IsUserLike) {
                            this.$set(this.tm, 'IsUserLike', true);
                        }
                        this.$set(this.tm, 'LikeCount', newClapsCount);
                    } else {
                        this.$dialog.alert(data.message);
                    }
                    loader.hide();
                } catch (error) {
                    if (error.response) {
                        // 當狀態碼不在 validateStatus 設定的範圍時進入, 401 感覺會跑來這。待確認
                        // 有 data / status / headers 參數可用
                        console.log(error.response.status);
                    } else if (error.request) {
                        // 發送請求，但沒有接到回應
                        // error.request is an instance of XMLHttpRequest in the browser
                        // and an instance of http.ClientRequest in node.js
                        console.log(error.request);
                    } else {
                        // 在設定 request 時出錯會進入此
                        console.log("Error", error.message);
                    }
                    this.$dialog.alert("無法拍手。發生不知名的錯誤");
                    loader.hide();
                }
            },
            getUserTML: async function () {
                var loader = this.$loading.show();

                try {
                    let res = await this.axios.post("Data/GetUserTeachingMaterialLexicons", {
                        tmId: this.tmId,
                    });

                    let data = res.data;

                    if (data.success) {
                        this.utmls = data.data;
                    } else {
                        this.$dialog.alert(data.message);
                    }
                    loader.hide();
                } catch (error) {
                    if (error.response) {
                        // 當狀態碼不在 validateStatus 設定的範圍時進入, 401 感覺會跑來這。待確認
                        // 有 data / status / headers 參數可用
                        console.log(error.response.status);
                    } else if (error.request) {
                        // 發送請求，但沒有接到回應
                        // error.request is an instance of XMLHttpRequest in the browser
                        // and an instance of http.ClientRequest in node.js
                        console.log(error.request);
                    } else {
                        // 在設定 request 時出錯會進入此
                        console.log("Error", error.message);
                    }
                    this.$dialog.alert("無法取得使用者收藏的生字表。發生不知名的錯誤");
                    loader.hide();
                }
            },
            addUserTML: async function (tml) {
                if (this.videoShareInfo) {
                    // from videoshare
                    this.$gtag.event('add_user_tml', {
                        'event_category': 'iyuyan',
                        'event_label': 'video_share',
                        'value': 200
                    });
                } else {
                    this.$gtag.event('add_user_tml', {
                        'event_category': 'iyuyan',
                        'event_label': 'material_study',
                        'value': 200
                    });
                }

                if (this.user) {
                    /* 先關閉點數限制 */
                    /*
                    if (this.tm.IsCollected) {
                        var loader = this.$loading.show();

                        try {
                            let res = await this.axios.post("Data/AddUserTeachingMaterialLexicon", {
                                tmId: this.tmId,
                                tmlId: tml.Id,
                            });

                            let data = res.data;

                            if (data.success) {
                                let addedTML = data.data;
                                this.utmls.push(addedTML);
                            } else {
                                this.$dialog.alert(data.message);
                            }
                            loader.hide();
                        } catch (error) {
                            if (error.response) {
                                // 當狀態碼不在 validateStatus 設定的範圍時進入, 401 感覺會跑來這。待確認
                                // 有 data / status / headers 參數可用
                                console.log(error.response.status);
                            } else if (error.request) {
                                // 發送請求，但沒有接到回應
                                // error.request is an instance of XMLHttpRequest in the browser
                                // and an instance of http.ClientRequest in node.js
                                console.log(error.request);
                            } else {
                                // 在設定 request 時出錯會進入此
                                console.log("Error", error.message);
                            }
                            this.$dialog.alert("無法新增使用者的收藏。發生不知名的錯誤");
                            loader.hide();
                        }
                    } else {
                        this.showBookmarkReminder();
                    }
                    */

                    var loader = this.$loading.show();

                    try {
                        let res = await this.axios.post("Data/AddUserTeachingMaterialLexicon", {
                            tmId: this.tmId,
                            tmlId: tml.Id,
                        });

                        let data = res.data;

                        if (data.success) {
                            let addedTML = data.data;
                            this.utmls.push(addedTML);
                        } else {
                            this.$dialog.alert(data.message);
                        }
                        loader.hide();
                    } catch (error) {
                        if (error.response) {
                            // 當狀態碼不在 validateStatus 設定的範圍時進入, 401 感覺會跑來這。待確認
                            // 有 data / status / headers 參數可用
                            console.log(error.response.status);
                        } else if (error.request) {
                            // 發送請求，但沒有接到回應
                            // error.request is an instance of XMLHttpRequest in the browser
                            // and an instance of http.ClientRequest in node.js
                            console.log(error.request);
                        } else {
                            // 在設定 request 時出錯會進入此
                            console.log("Error", error.message);
                        }
                        this.$dialog.alert("無法新增使用者的收藏。發生不知名的錯誤");
                        loader.hide();
                    }
                } else {
                    let loginHint = this.$t('page_material_study.login_hint');
                    this.$dialog.alert(loginHint);
                }
            },
            removeUserTML: async function (utml, utmlIdx) {
                if (this.videoShareInfo) {
                    // from videoshare
                    this.$gtag.event('remove_user_tml', {
                        'event_category': 'iyuyan',
                        'event_label': 'video_share',
                        'value': 100
                    });
                } else {
                    this.$gtag.event('remove_user_tml', {
                        'event_category': 'iyuyan',
                        'event_label': 'material_study',
                        'value': 100
                    });
                }

                var loader = this.$loading.show();
                try {
                    let res = await this.axios.post("Data/RemoveUserTeachingMaterialLexicon", {
                        tmlId: utml.TeachingMaterialLexiconId,
                    });

                    let data = res.data;

                    if (data.success) {
                        this.utmls.splice(utmlIdx, 1);
                    } else {
                        this.$dialog.alert(data.message);
                    }
                    loader.hide();
                } catch (error) {
                    if (error.response) {
                        // 當狀態碼不在 validateStatus 設定的範圍時進入, 401 感覺會跑來這。待確認
                        // 有 data / status / headers 參數可用
                        console.log(error.response.status);
                    } else if (error.request) {
                        // 發送請求，但沒有接到回應
                        // error.request is an instance of XMLHttpRequest in the browser
                        // and an instance of http.ClientRequest in node.js
                        console.log(error.request);
                    } else {
                        // 在設定 request 時出錯會進入此
                        console.log("Error", error.message);
                    }
                    this.$dialog.alert("無法移除使用者的收藏。發生不知名的錯誤");
                    loader.hide();
                }
            },
            getUserTM: async function () {
                var loader = this.$loading.show();

                try {
                    let res = await this.axios.post("Material/GetUserTeachingMaterial", {
                        tmId: this.tmId,
                    });

                    let data = res.data;

                    if (data.success) {
                        this.tm = data.data;

                        this.getVideoCaptions();
                    } else {
                        this.$dialog.alert(data.message);
                    }
                    loader.hide();
                } catch (error) {
                    if (error.response) {
                        // 當狀態碼不在 validateStatus 設定的範圍時進入, 401 感覺會跑來這。待確認
                        // 有 data / status / headers 參數可用
                        console.log(error.response.status);
                    } else if (error.request) {
                        // 發送請求，但沒有接到回應
                        // error.request is an instance of XMLHttpRequest in the browser
                        // and an instance of http.ClientRequest in node.js
                        console.log(error.request);
                    } else {
                        // 在設定 request 時出錯會進入此
                        console.log("Error", error.message);
                    }
                    this.$dialog.alert("無法取得影片學習資訊。發生不知名的錯誤");
                    loader.hide();
                }
            },
            getVideoCaptions: async function () {
                let loader = this.$loading.show();

                await this.$recaptchaLoaded();

                const token = await this.$parent.$recaptcha('Data/GetVideoCaptions');

                try {
                    let res = await this.axios.post("Data/GetVideoCaptions", {
                        re: token,
                        v: this.videoId,
                        l: this.tm.LangCharsetCodeLearning,
                        cc: false,
                    });

                    let data = res.data;

                    if (data.success) {
                        this.videoCaptions = data.data;

                        let dictVideoCaptions = {};
                        this.videoCaptions.forEach(function (vc, idx) {
                            dictVideoCaptions[vc.Id] = {
                                idx: idx,
                                cap: vc,
                            };
                        });
                        this.dictVideoCaptions = dictVideoCaptions;
                    } else {
                        this.$dialog.alert(data.message);
                    }
                    loader.hide();
                } catch (error) {
                    if (error.response) {
                        // 當狀態碼不在 validateStatus 設定的範圍時進入, 401 感覺會跑來這。待確認
                        // 有 data / status / headers 參數可用
                        console.log(error.response.status);
                    } else if (error.request) {
                        // 發送請求，但沒有接到回應
                        // error.request is an instance of XMLHttpRequest in the browser
                        // and an instance of http.ClientRequest in node.js
                        console.log(error.request);
                    } else {
                        // 在設定 request 時出錯會進入此
                        console.log("Error", error.message);
                    }
                    this.$dialog.alert("無法取得影片字幕資訊。發生不知名的錯誤");
                    loader.hide();
                }
            },
            getAdaptedTMCs: async function () {
                var loader = this.$loading.show();

                try {
                    let res = await this.axios.post("Material/GetAdaptedTMCs", {
                        v: this.videoId,
                        tmid: this.tmId,
                    });

                    let data = res.data;

                    if (data.success) {
                        this.tmcs = data.data;

                        let dictTMCS = {};
                        for (let curTMC of this.tmcs) {
                            dictTMCS[curTMC.VideoCaptionId] = curTMC;
                        }
                        this.dictTMCS = dictTMCS; // 這樣就可以用 this.dictTMCS[VideoCaptionId] 抓到對應的翻譯資料
                    } else {
                        this.$dialog.alert(data.message);
                    }
                    loader.hide();
                } catch (error) {
                    if (error.response) {
                        // 當狀態碼不在 validateStatus 設定的範圍時進入, 401 感覺會跑來這。待確認
                        // 有 data / status / headers 參數可用
                        console.log(error.response.status);
                    } else if (error.request) {
                        // 發送請求，但沒有接到回應
                        // error.request is an instance of XMLHttpRequest in the browser
                        // and an instance of http.ClientRequest in node.js
                        console.log(error.request);
                    } else {
                        // 在設定 request 時出錯會進入此
                        console.log("Error", error.message);
                    }
                    this.$dialog.alert("無法取得例句翻譯。發生不知名的錯誤");
                    loader.hide();
                }
            },
            getAllTML: async function () {
                var loader = this.$loading.show();

                try {
                    let res = await this.axios.post("Material/GetAllTML", {
                        vid: this.videoId,
                        tmid: this.tmId,
                    });

                    let data = res.data;

                    if (data.success) {
                        this.tmls = data.data;

                        let dictTMLS = {};
                        for (let curTML of this.tmls) {
                            dictTMLS[curTML.Id] = curTML;
                        }

                        this.dictTMLS = dictTMLS;
                    } else {
                        this.$dialog.alert(data.message);
                    }
                    loader.hide();
                } catch (error) {
                    if (error.response) {
                        // 當狀態碼不在 validateStatus 設定的範圍時進入, 401 感覺會跑來這。待確認
                        // 有 data / status / headers 參數可用
                        console.log(error.response.status);
                    } else if (error.request) {
                        // 發送請求，但沒有接到回應
                        // error.request is an instance of XMLHttpRequest in the browser
                        // and an instance of http.ClientRequest in node.js
                        console.log(error.request);
                    } else {
                        // 在設定 request 時出錯會進入此
                        console.log("Error", error.message);
                    }
                    this.$dialog.alert("無法取得生字表。發生不知名的錯誤");
                    loader.hide();
                }
            },
            initData: function () {
                this.getVideoInfo();
                this.getVideoLexiconFindingStatistic();
                this.getUserTM();
                this.getAdaptedTMCs();
                //this.getAllTML();
                this.getTeachingMaterialTags();

                if (this.user) {
                    this.getUserTML();
                }
            },
        },
        computed: {
            fbDataUrl: function () {
                // old url
                //let dataUrl = process.env.VUE_APP_FB_COMMENT_BASE_URL + '/Video/PlayVideoBS?v=' + this.videoId;

                let dataUrl = null;
                // 每個教材一個專屬的留言網址
                dataUrl = process.env.VUE_APP_FB_COMMENT_BASE_URL + '/Material/Study/' + this.videoId + '/' + this.tmId;
                /*
                if (this.videoShareInfo) {
                    dataUrl = process.env.VUE_APP_FB_COMMENT_BASE_URL + '/VideoShare/Index4/' + this.videoShareInfo.VideoShareId;
                } else {
                    // 每個教材一個專屬的留言網址
                    dataUrl = process.env.VUE_APP_FB_COMMENT_BASE_URL + '/Material/Study/' + this.videoId + '/' + this.tmId;
                }
                */

                return dataUrl;
            },
            fmtAccentTypeName: function () {
                if (this.accentTypes && this.videoInfo && this.videoInfo.AccentTypeId) {
                    let accentTypes = this.accentTypes[this.videoInfo.VideoLang];
                    for (let at of accentTypes) {
                        if (at.Id == this.videoInfo.AccentTypeId) {
                            return at.Name;
                        }
                    }
                }

                return '錯誤的口音資料';
            },
            fmtAuthorAvatorUrl: function () {
                if (this.tm) {
                    return fmtAuthorAvatorUrl(this.tm);
                }

                return null;
            },
            getVideoLoadStart: function () {
                if (this.videoStart) {
                    return this.videoStart;
                } else if (this.videoCaptions && this.tmcs) {
                    return Math.floor(this.tmcs[0].Start);
                }

                return 0;
            }
        },
        mounted: function () {
            this.initData();
        },
        watch: {
            user: function (newVal) {
                if (newVal) {
                    this.getUserTML();
                }
            },
        },
        created() { },
        metaInfo() {
            return {
                // ideas from here: https://www.epiloge.com/how-to-add-dynamic-meta-tags-to-your-vuejs-app-for-google-seo-0fa058
                meta: [
                    { property: 'og:locale', content: 'zh_TW' },
                    { property: 'og:title', content: `${this.videoShareInfo.VideoTitle}` },
                    { property: 'og:type', content: 'website' },
                    { property: 'og:url', content: `${window.location.href.split('?')[0]}` },
                    { property: 'og:description', content: '愛語言 - 您的線上語言自學平台。以資訊科技與影音，翻轉你的語言學習體驗' },
                    { property: 'og:image', content: `${this.videoShareInfo.ImageUrl}`},
                    { property: 'og:image:type', content: 'image/jpg' },
                    { property: 'og:image:width', content: `${this.videoShareInfo.ImageHeight}` },
                    { property: 'og:image:height', content: `${this.videoShareInfo.ImageHeight}` },
                ]
            }
        },
    };
</script>
<style>
    .tm-wrapper {
        padding-bottom: 100px;
    }

    .tm-wrapper h1 {
        font-size: 2rem;
    }

    .anthorCricle-image {
        width: 40px !important;
        height: 40px !important;
        border: 1px solid #ebebeb;
        border-radius: 50%;
        overflow: hidden;
        background-color: #a9a9a9;
        cursor: pointer;
    }

    .tm-wrapper h2 {
        font-size: 1.2rem;
    }



    .tmls-title {
        cursor: pointer;
        position: relative;
    }

    .tmls-title::after {
        content: url('~@/assets/image/videoCaptions-voice.svg');
        width: 50px;
        height: 50px;
        margin-left: 6px;
        opacity: 0;
        position: relative;
        top: 2px;
        cursor: pointer;
    }

        .tmls-title:hover {
            text-decoration: underline;
        }

        .tmls-title-wrap:hover .tmls-title::after {
            opacity: 1;
        }

    .tmls-content-wrap{
        height: 570px;
        overflow-y: auto;
        position: relative;
    }

    @media screen and (min-width: 1240px) {
        .gradual-mask{
            position: absolute;
            bottom: 79px;
            width: 100%;
            left: 0px;
            right: 0px;
            height: 35px;
            /* Permalink - use to edit and share this gradient: https://colorzilla.com/gradient-editor/#ffffff+1,ffffff+40&0+0,1+40 */
            background: -moz-linear-gradient(top, rgba(255,255,255,0) 0%, rgba(255,255,255,0.03) 1%, rgba(255,255,255,1) 40%); /* FF3.6-15 */
            background: -webkit-linear-gradient(top, rgba(255,255,255,0) 0%,rgba(255,255,255,0.03) 1%,rgba(255,255,255,1) 40%); /* Chrome10-25,Safari5.1-6 */
            background: linear-gradient(to bottom, rgba(255,255,255,0) 0%,rgba(255,255,255,0.03) 1%,rgba(255,255,255,1) 40%); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
            filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#00ffffff', endColorstr='#ffffff',GradientType=0 ); /* IE6-9 */
        }
        
    }


    /* 右側欄 */
    /*******************************
        * MODAL AS LEFT/RIGHT SIDEBAR
        * Add "left" or "right" in modal parent div, after class="modal".
        * Get free snippets on bootpen.com
        *******************************/
    .right .modal .modal-dialog {
        position: fixed;
        margin: auto;
        width: 320px;
        height: 100%;
        -webkit-transform: translate3d(0%, 0, 0);
        -ms-transform: translate3d(0%, 0, 0);
        -o-transform: translate3d(0%, 0, 0);
        transform: translate3d(0%, 0, 0);
    }

    .right .modal .modal-content {
        height: 100%;
        overflow-y: auto;
    }

    .right .modal .modal-body {
        padding: 15px 15px 80px;
    }

    /*Right*/
    .right .fade .modal-dialog {
        right: -320px;
        -webkit-transition: opacity 0.3s linear, right 0.3s ease-out;
        -moz-transition: opacity 0.3s linear, right 0.3s ease-out;
        -o-transition: opacity 0.3s linear, right 0.3s ease-out;
        transition: opacity 0.3s linear, right 0.3s ease-out;
    }

    .right .fade .modal-dialog {
        right: 0;
    }

    /* ----- MODAL STYLE ----- */
    /* .modal-content {
        border-radius: 0;
        border: none;
    }

    .modal-header {
        border-bottom-color: #eeeeee;
        background-color: #fafafa;
    }


    .demo {
        padding-top: 60px;
        padding-bottom: 110px;
    }

    .btn-demo {
        margin: 15px;
        padding: 10px 15px;
        border-radius: 0;
        font-size: 16px;
        background-color: #ffffff;
    }

    .btn-demo:focus {
        outline: 0;
    }

    .demo-footer {
        position: fixed;
        bottom: 0;
        width: 100%;
        padding: 15px;
        background-color: #212121;
        text-align: center;
    }

    .demo-footer>a {
        text-decoration: none;
        font-weight: bold;
        font-size: 16px;
        color: #fff;
    }

    .modal-backdrop {
        display: none;
    }

    #exampleModal {
        max-width: 380px;
    }

    .modal-backdrop {
        max-width: 380px;
    }

    .modal-content {
        box-shadow: 0 1px 12px rgb(0 0 0 / 19%);
        z-index: 99999999999;
        border-radius: 10px;
        background-color: hsla(0, 0%, 100%, .9);
    } */

    .fa-trash {
        color: #D3D3D3;
        cursor: pointer;
    }

    .fa-trash:hover {
        color: #FF6072;
    }

    .toolBtn-wrap {
        position: absolute;
        bottom: 3%;
        left: 50%;
        transform: translate(-50%, 0%);
        box-shadow: 0 1px 12px rgb(0 0 0 / 19%);
        padding: 10px 10px;
        border-radius: 10px;
        display: flex;
        align-items: center;
        min-width: auto;
        z-index: 11;
        background-color: #fff;
    }

    .scrollTop {
        display: none;
    }
    

    @media screen and (max-width:700px) {
        .toolBtn-wrap {
            position: fixed;
            z-index: 9;
            background-color: #fff;
            bottom: 3%;
        }

        .toolBtn-wrap {
            min-width: 330px;
        }

        .toolBtn-wrap .btn {
            font-size: .9rem;
            padding: 5px 10px;
        }

        .right .modal .modal-dialog {
            width: 100%;
        }

        .modal-content {
            background-color: hsla(0, 0%, 100%, 1);
        }

        /* .modal-header {
            position: fixed;
            right: 0px;
            left: 0px;
            z-index: 99;
        } */

        .modal-body {
            padding-top: 81px !important
        }

        .videoCaptionsData-wrap {
            overflow-y: none;
            height: 420px!important;
            padding: 0px 0px;
            margin-top: 30px;
        }

        .scrollTop {
            position: fixed;
            right: 0px;
            bottom: 84px;
            padding: 10px;
            border-radius: 50px;
            background-color: #fff;
            box-shadow: 0 1px 12px rgb(0 0 0 / 19%);
            display: block;
        }

        .toolBtn-wrap .btn.scrollTop:hover {
            border-radius: 50px;
            background-color: #fff;
        }

        .tm-num-text {
            font-size: .9rem;
        }
    }


    .toolBtn-wrap .btn:hover {
        background-color: #f2f2f2;
        border-radius: 5px;
    }

    .btn-line {
        width: 2px;
        height: 20px;
        background-color: #000;
    }

    #studyNotes textarea {
        width: 100%;
        border: 2px solid;
        border-radius: 5px;
    }

    .fa-share-alt-square {
        color: #c2c2c2;
        font-size: 1.4rem;
        cursor: pointer;
    }

    .fa-share-alt-square:hover {
        color: #456CEB;
    }

    .materialStudy-wrap {
        width: 100%;
        height: 100%;
        max-width: 1770px;
        margin-right: auto;
        margin-left: auto;
        overflow: hidden;
        position: relative;
        text-align: left;
        padding: 0% 10%;
    }

    .materialStudy-wrap .tm-wrapper {
        width: 100%;
        display: flex;
        position: relative;
        z-index: 10;
        transition: all 0.6s;
        /* background-color: rgb(218, 255, 218); */
    }

    .tm-wrapper.move {
        margin-left: -17%;
    }

    /* .tranglationBody.active {
        right: 0px;
    } */

    .tranglationBody {
        width: 24%;
        display: block;
        height: 100%;
        position: absolute;
        top: 0px;
        right: -26%;
        box-shadow: 0px 0px 12px rgb(0 0 0 / 20%);
        transition: all 0.6s;
        padding-top: 20px;
        padding-right: 30px;
        padding-left: 30px;
        overflow-y: auto;
        /*user-select: none;*/
        background-color: #fff;
        z-index: 99;
        right: 0px;
    }

    .tranglationBodyNotebook {
        width: 50%;
        display: block;
        height: 100%;
        position: absolute;
        top: 0px;
        right: -26%;
        box-shadow: 0px 0px 12px rgb(0 0 0 / 20%);
        transition: all 0.6s;
        padding-top: 20px;
        padding-right: 30px;
        padding-left: 30px;
        overflow-y: auto;
        /*user-select: none;*/
        background-color: #fff;
        z-index: 99;
        right: 0px;
    }

    .nav-tabs .nav-link.active, .nav-tabs .nav-item.show .nav-link{
        border:0px;
    }

    .nav-tabs .nav-link {
        cursor: pointer;
    }   

    .modal-title{
        margin-bottom: 25px;
    }

    .videoCaptionsData-title{
        margin-bottom: 4px;
        margin-top: 36px;
        font-weight: 600;
    }

    .nav-tabs .nav-link:hover, .nav-tabs .nav-link:focus {
        border-color: rgba(255, 255, 255, 0);
        background-color: #a9a9a92a;
        border-radius: 5px;
    }

    .close-btn{
        position: absolute;
        right: 10px;
        top:10px;
        cursor: pointer;
    }
    .fa-times{
        color:rgb(174, 174, 174);
    }

    .bookmarks::before {
        content: url('/img/title-bookmarks.svg');
        height: 25px;
        margin-right: 9px;
    }

    .bookmarks-active {
        content: url('/img/title-bookmarks-active.svg');
        height: 25px;
        margin-right: 9px;
    }

    .list-wrap-border{
        border-bottom: 1px solid rgb(223, 223, 223);
        margin-top: 16px;
    }

    .list-wrap-border:nth-last-child(1){
        border-bottom: 0px;
    }

    .fa-plus{
        color: #c2c2c2;
    }
    .fa-plus:hover{
        color: #456CEB;
    }

    .tranglationBodyNotebook textarea {
        /*
            border-color: #e3e3e3;
        */
        border: 1px solid lightgray !important;
        width: 100%;
        border-radius: 5px;
    }

    .close-video{
        display: none;
    }

    .extendLearn-img{
        height: 160px;
        cursor: pointer;
    }

    .bookmarks-remind{
        position: absolute;
        z-index: 99999;
        font-size: 20px;
        line-height: 30px;
        padding: 13px;
        top: -27px;
        left: 50px;
        width: 224px;
        color: #fff;
        border-radius: 10px;
        background-color: #456CEB;
        border: 2px solid #456CEB;
        display: none;
    }

    .remind-tringle{
        width: 0;
        height: 0;
        border-style: solid;
        border-width: 0 16px 16px 16px;
        transform : rotate(-90deg);
        border-color: transparent transparent #456CEB transparent;
        position: absolute;
        left: -21px;
        top: 44px;
    }

    .bookmarks-remind .close-btn {
        position: absolute;
        color: #fff !important;
        background-color: #a9a9a9;
        border-radius: 50%;
        width: 30px;
        right: -10px;
        top: -10px;
        text-align: center;
    }

    .bookmarks-remind .fa-times {
        z-index: 99999;
        color: #fff !important;
    }

    .show{
        display: block;
    }

    .label-primary{
        background-color: #71d8bc;
        border-radius: 5px;
        font-size: 12px;
        padding: 5px 10px;
        display: flex;
        color: #fff;
    }

    .fb-comments iframe {
        width: 100%;
    }

    @media screen and (max-width:900px) {
        .nav.toolBtn-wrap {
            flex-wrap: nowrap;
            width: 402px;
            max-width: 402px;
            z-index: 999;
            background-color: #FFF;
        }

        .nav.toolBtn-wrap .nav-link{
            font-size: 16px;
        }
        .materialStudy-wrap {
            padding: 0% 5%;
        }
        .tmls-content-wrap {
            height: 74vh;
            overflow-y: auto;
            position: relative;
        }
        .tranglationBody {
            width: 100%;
            height: 100%;
            position: fixed;
            right: 0!important;
            left: 0!important;
            z-index: 999999;
        }
        .tranglationBodyNotebook {
            width: 100%;
            height: 100%;
            position: fixed;
            right: 0 !important;
            left: 0 !important;
            z-index: 999999;
        }
        .extendLearn-img{
            height: 250px;
        }
    }

    @media screen and (min-width:1200px){
        .tranglationBody {
            max-width:350px;
        }
    } 

    @media screen and (max-width:450px) {
        .nav.toolBtn-wrap {
            width: 320px;
            max-width: 320px;
        }

        .nav.toolBtn-wrap .nav-link{
            font-size: 15px;
            padding: 0px 5px;
        }
        .btn-line {
            width: 1px;
            background-color: rgb(106, 106, 106);
        }
        .nav.toolBtn-wrap {
            width: 300px!important;
            max-width: 300px!important;
            min-width: 300px!important;
        }

    }
</style>